export default __webpack_public_path__ + "static/media/skyniche-christmas.939c0870.gif";